import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const withdrawalSchema = z.object({
  /** Order ID, e.g. `"1"` */
  orderId: z.string(),
  /** TX ID, e.g. `"1"` */
  tradeId: z.string(),
  /** Token name, e.g. `"USDT"` */
  coin: z.string(),
  /** Withdrawal of coins, e.g. `"dest"` */
  dest: z.string(),
  /** Client customized ID, e.g. `"123"` */
  clientOid: z.string().nullable(),
  /** Type, e.g. `"withdraw"` */
  type: z.string(),
  /** Tag, e.g. `""` */
  tag: z.string().nullable(),
  /** Quantity, e.g. `"10.00000000"` */
  size: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Transaction Fee, e.g. `"-1.00000000"` */
  fee: z
    .string()
    .regex(/^-?\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Withdrawal status */
  status: z.union([
    z.literal('pending'),
    z.literal('fail'),
    z.literal('success'),
  ]),
  /** withdrawing banknote (i.e. banknotes etc), e.g. `"1"` */
  toAddress: z.string(),
  /** coin-raising, e.g. `"2"` */
  fromAddress: z.string().nullable(),
  /** Number of confirmed blocks, e.g. `"100"` */
  confirm: z.string(),
  /** Ticin network, e.g. `"erc20"` */
  chain: z.string(),
  /** Creation time, e.g. `"1653290769222"` */
  cTime: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number.parseInt(v, 10)),
  /** Edit time, e.g. `"1653290769222"` */
  uTime: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number.parseInt(v, 10)),
})

export type Withdrawal = z.infer<typeof withdrawalSchema>
